<template>
  <div class="regionalCoverage" :class="isAutoExportPng ? 'autoExportPng' : ''">
    <div class="rCcanvas_box" :id="fatherDivId">
      <canvas
        class="canvas"
        :class="direction === 'vertical' ? 'vertical' : ''"
        @click.stop="downLoad(canvasDom, false)"
        :id="canvasId"
      ></canvas>
    </div>
  </div>
</template>

<script>
/*
 * 主题：防守区域
 * 多边形图形组件说明：
 * 传入参数：
 * 1.pointsData  多边形数据 Array 一个数组包含所有球员的点数据
 *[{'player_id': '100887', 'x': '11.6', 'y': '54.6'}]
 * 2.direction  方向 传入值 === vertical 时显示为 竖直方向，不传默认横向
 *方法说明：
 * 1.导出图片方法为  savePng  在父组件调用可采用 $ref 的方式使用，传入参数为图片名称，使用png方式导出
 *
 * */
import _ from 'lodash'
import datas from './regionalCoverage.json'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'regionalCoverage',
  mixins: [canvasToImage_base64_data_mixin],
  data() {
    return {
      fatherDivId: Math.random(),
      canvasId: Math.random(),
      canvasDom: null,
      pointsMap: {},
      data: [],
      minPoint: [],
      maxYPoint: {},
      startPoint: {},
      compareFlag: 'right',
      ratio: 0,
    }
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    direction: {},
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  created() {
    // this.pointsData = this.datas.data.dataList
  },
  mounted() {
    this.$nextTick(() => {
      this.refresh()
    })
  },
  watch: {
    datas() {
      this.refresh()
    },
  },
  methods: {
    changeRatio() {
      this.canvasDom = document.getElementById(this.canvasId)
      let canvas = this.canvasDom
      let ctx = canvas.getContext('2d')
      // 屏幕的设备像素比
      let devicePixelRatio = window.devicePixelRatio || 1
      // 浏览器在渲染canvas之前存储画布信息的像素比
      let backingStoreRatio =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      // canvas的实际渲染倍率
      this.ratio = devicePixelRatio / backingStoreRatio
      let fatherDiv = document.getElementById(this.fatherDivId)
      let fWidth = fatherDiv.offsetWidth
      console.debug('fWidth:', fWidth)
      if (this.direction === 'vertical') {
        canvas.style.width = fWidth + 'px'
        // canvas.style.height = (fWidth / 1084) * 1614 + 'px'
        canvas.style.height = Math.floor(fWidth / 1.53) + 'px'
        canvas.width = fWidth * this.ratio
        // canvas.height = (fWidth / 1084) * 1614 * this.ratio
        canvas.height = Math.floor(fWidth / 1.53) * this.ratio
      } else {
        canvas.style.width = fWidth + 'px'
        // canvas.style.height = (fWidth / 1614) * 1084 + 'px'
        canvas.style.height = Math.floor(fWidth / 1.53) + 'px'
        canvas.width = fWidth * this.ratio
        // canvas.height = (fWidth / 1614) * 1084 * this.ratio
        canvas.height = Math.floor(fWidth / 1.53) * this.ratio
      }
    },
    render() {
      let arrayData = _.cloneDeep(this.datas.data.dataList)
      // arrayData = []
      arrayData.forEach((point) => {
        let id = point.playerName ? point.playerName : point.shirtNumber
        if (this.direction === 'vertical') {
          let x = _.cloneDeep(point.x)
          let y = _.cloneDeep(point.y)
          point.x = 100 - _.toNumber(y)
          point.y = 100 - _.toNumber(x)
        } else {
          let x = _.cloneDeep(point.x)
          let y = _.cloneDeep(point.y)
          point.x = _.toNumber(x)
          point.y = 100 - _.toNumber(y)
        }
        if (!this.pointsMap[id]) {
          let single = {
            id: id,
            points: [],
          }
          single.points.push(point)
          this.pointsMap[id] = single
        } else {
          this.pointsMap[id].points.push(point)
        }
      })
      let x = 0
      for (let i in this.pointsMap) {
        // if ( x > 11 ) {
        //   return
        // }
        this.renderSingle(this.pointsMap[i])
        x++
      }
    },
    renderSingle(data) {
      if (data.points.length === 1) {
        this.renderPoint(data)
        return
      }
      this.data = []
      this.compareFlag = 'right'
      this.startPoint = []
      this.minPoint = []
      this.maxYPoint = {}
      this.data = _.cloneDeep(data.points)
      this.findMinBoundPolygon()
      this.renderPolygon()
      let mass = this.findMassCenter({
        id: data.id,
        points: this.minPoint,
      })
      if (mass) {
        this.renderP(mass, data)
      }
    },
    findMinBoundPolygon() {
      this.data = _.orderBy(this.data, ['y', 'x'], ['asc', 'asc'])
      this.startPoint = this.data[0]
      this.maxYPoint = this.data[this.data.length - 1]
      this.minPoint.push(this.startPoint)
      this.judgeNextPoint(this.startPoint, 0)
    },
    judgeNextPoint(start, startindex) {
      let next, nextPoint, nextIndex
      this.data.forEach((point, index) => {
        if (!point.checked) {
          let angle = this.angle(start, point)
          if (
            this.compareFlag === 'right' &&
            angle > 0 &&
            (angle < next || next === undefined)
          ) {
            next = angle
            nextPoint = point
            nextIndex = index
          } else if (
            this.compareFlag === 'left' &&
            angle < 0 &&
            (angle < next || next === undefined)
          ) {
            next = angle
            nextPoint = point
            nextIndex = index
          }
        }
      })
      if (
        nextPoint.x === this.maxYPoint.x &&
        nextPoint.y === this.maxYPoint.y
      ) {
        this.compareFlag = 'left'
      }
      if (
        nextPoint.x === this.startPoint.x &&
        nextPoint.y === this.startPoint.y
      ) {
      } else {
        this.minPoint.push(nextPoint)
        nextPoint.checked = true
        this.data.splice(nextIndex, 1, nextPoint)
        this.judgeNextPoint(nextPoint, nextIndex)
      }
    },
    angle(start, end) {
      return Math.atan2(end.y - start.y, end.x - start.x)
    },
    renderPolygon() {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      ctx.fillStyle = 'rgba(151,220,201,0.6)'
      ctx.strokeStyle = '#25AE87'
      ctx.beginPath()
      ctx.moveTo((this.startPoint.x * w) / 100, (this.startPoint.y * h) / 100)
      this.minPoint.forEach((point) => {
        ctx.lineTo((point.x * w) / 100, (point.y * h) / 100)
      })
      ctx.lineTo((this.startPoint.x * w) / 100, (this.startPoint.y * h) / 100)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    },
    renderPoint(data) {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      let point = data.points[0]
      ctx.beginPath()
      ctx.fillStyle = 'rgba(65,117,82,1)'
      ctx.arc((point.x * w) / 100, (point.y * h) / 100, 3, 0, Math.PI * 2)
      ctx.fill()
      ctx.closePath()
    },
    renderP(point, data) {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      ctx.beginPath()
      ctx.fillStyle = data ? 'blue' : 'red'
      ctx.arc((point.x * w) / 100, (point.y * h) / 100, 3, 0, Math.PI * 2)
      ctx.fill()
      ctx.closePath()
      if (data && data.id) {
        ctx.beginPath()
        ctx.font = '16px sans-serif'
        ctx.fillStyle = '#000'
        ctx.textAlign = 'start'
        ctx.fillText(data.id, (point.x * w) / 100, (point.y * h) / 100 + 20)
        ctx.closePath()
      }
    },
    findMassCenter(data) {
      if (data.points.length === 1) {
        return data.points[0]
      } else if (data.points.length === 2 || data.points.length === 3) {
        let x = 0,
          y = 0
        data.points.forEach((p) => {
          x += p.x
          y += p.y
        })
        if (data.points.length === 3) {
          let area = this.findTriangleArea(
            data.points[0],
            data.points[1],
            data.points[2]
          )
        }
        return {
          x: x / data.points.length,
          y: y / data.points.length,
        }
      }
      if (data.points.length > 3) {
        let sum_x = 0,
          sum_y = 0,
          sum_area = 0
        for (let i = 2; i < data.points.length; i++) {
          let p1 = data.points[0]
          let p2 = data.points[i - 1]
          let p3 = data.points[i]
          let area = this.findTriangleArea(p1, p2, p3)
          sum_area += area
          sum_x += (p1.x + p2.x + p3.x) * area
          sum_y += (p1.y + p2.y + p3.y) * area
        }
        return {
          x: sum_x / sum_area / 3,
          y: sum_y / sum_area / 3,
        }
      } else {
        return false
      }
    },
    findTriangleArea(p1, p2, p3) {
      return ((p2.x - p1.x) * (p3.y - p1.y) - (p3.x - p1.x) * (p2.y - p1.y)) / 2
    },
    refresh() {
      let c = document.getElementById(this.canvasId)
      this.pointsMap = {}
      c.height = c.height
      if (!this.initFlag) {
        this.initFlag = true
        this.changeRatio()
      }
      this.render()
      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(c, false, 'uploadData')
        }, 500)
      }
    },
    savePng(fileName) {
      let name = fileName || '测试'
      let canvasElement = document.getElementById(this.canvasId)

      let MIME_TYPE = 'image/png'

      let imgURL = canvasElement.toDataURL(MIME_TYPE)

      let dlLink = document.createElement('a')
      dlLink.download = name
      dlLink.href = imgURL
      dlLink.dataset.downloadurl = [
        MIME_TYPE,
        dlLink.download,
        dlLink.href,
      ].join(':')

      document.body.appendChild(dlLink)
      dlLink.click()
      document.body.removeChild(dlLink)
    },
  },
}
</script>

<style lang="scss" scoped>
.regionalCoverage {
  width: 59%;
  border: 0.416vw solid #eaedf1;
  background: #eaedf1;
  border-radius: 0.694vw;
  &.autoExportPng {
    width: 100%;
  }
  .rCcanvas_box {
    width: 100%;
    font-size: 0;
  }
}
.canvas {
  /* background: url('./images/newball.png') 100% 100% no-repeat; */
  background-image: var(--mixtmt_ball_bg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.vertical {
  background: var(--mixtmt_regionalCoverage_fieldVertical_bg) 100% 100%
    no-repeat;
  -webkit-background-size: contain;
  background-size: contain;
}
</style>
